import { dateStringSort } from 'helpers';
import { Option } from 'types/Form';

export const trancheOptionSort = (a: Option, b: Option) => {
  if (a.subLabel && b.subLabel) {
    return dateStringSort(a.subLabel, b.subLabel);
  }
  if (a.subLabel) {
    return -1;
  }
  if (b.subLabel) {
    return 1;
  }
  return (b.value as number) - (a.value as number);
};

export const convertStringBool = (stringBool: string) => {
  return stringBool === 'true';
};

export const handleDerogOptions = (value: string) => {
  switch (value) {
    case 'with_derog':
      return true;
    case 'without_derog':
      return false;
    default:
      return undefined;
  }
};
